<app-tpl-search>
  <div facet>
    <app-partners-search-facets [searchFacets]="facets | async" (filterFacets)="handleSearchFacets($event)"> </app-partners-search-facets>
  </div>

  <div query>
    <app-partners-search-query [facetFilters]="facetFilters" (searchChange)="handleSearchQuery($event)"> </app-partners-search-query>
  </div>

  <div result>
    <app-partners-search-result
      [domainsObs]="domains.asObservable()"
      [markets]="markets"
      [languages]="languages"
      [searchResult]="searchResult.asObservable()"
      (pageEmitter)="handleSearchPage($event)"
      (sortEmitter)="handleSearchSorted($event)"
    >
    </app-partners-search-result>
  </div>
</app-tpl-search>
